const REFRESH_FLAG = "qyon_panel_chunk_reload";
const STABLE_CLEAR_MS = 15000;

function isChunkLoadError(reason) {
  const message = reason?.message || String(reason || "");
  return /Loading chunk [\d]+ failed|ChunkLoadError|Failed to fetch dynamically imported module|error loading dynamically imported module/i.test(
    message
  );
}

function isSameOriginBuildAsset(target) {
  if (!target || !(target.tagName === "SCRIPT" || target.tagName === "LINK")) {
    return false;
  }

  const assetUrl = target.src || target.href;
  if (!assetUrl) return false;

  try {
    const url = new URL(assetUrl, window.location.href);
    if (url.origin !== window.location.origin) return false;
    return (
      url.pathname.startsWith("/static/") ||
      /\.(js|css)$/i.test(url.pathname)
    );
  } catch {
    return false;
  }
}

export async function forceAppRefresh() {
  // One recovery attempt per tab session. Clearing this too early (on boot)
  // caused infinite reload loops when chunks kept failing after deploy/rollback.
  if (sessionStorage.getItem(REFRESH_FLAG) === "1") {
    return;
  }

  sessionStorage.setItem(REFRESH_FLAG, "1");

  try {
    if ("caches" in window) {
      const cacheNames = await caches.keys();
      await Promise.all(
        cacheNames.map((cacheName) => caches.delete(cacheName))
      );
    }

    if ("serviceWorker" in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(
        registrations.map((registration) => registration.unregister())
      );
    }
  } catch (error) {
    console.error("Failed to clear app cache before refresh:", error);
  } finally {
    const url = new URL(window.location.href);
    url.searchParams.set("_v", String(Date.now()));
    window.location.replace(url.toString());
  }
}

export function clearAppRefreshFlag() {
  sessionStorage.removeItem(REFRESH_FLAG);
}

/** Clear the one-shot guard only after the page has been stable for a while. */
export function scheduleAppRefreshFlagClear() {
  const clear = () => {
    window.setTimeout(() => {
      clearAppRefreshFlag();
    }, STABLE_CLEAR_MS);
  };

  if (document.readyState === "complete") {
    clear();
    return;
  }

  window.addEventListener("load", clear, { once: true });
}

export function registerChunkLoadRecovery() {
  window.addEventListener(
    "error",
    (event) => {
      if (isSameOriginBuildAsset(event.target)) {
        forceAppRefresh();
      }
    },
    true
  );

  window.addEventListener("unhandledrejection", (event) => {
    if (isChunkLoadError(event.reason)) {
      forceAppRefresh();
    }
  });
}
